import React from 'react';

interface ColorModalPositionParameters {
    bottom: number;
    height: number;
    left: number;
    right: number;
    top: number;
    width: number;
    x: number;
    y: number;
}

interface ColorModalProps {
    changeColor: (color: string) => void;
    ColorModalPositionParameters: ColorModalPositionParameters;
}

const ColorModal: React.FC<ColorModalProps> = ({
    changeColor,
    ColorModalPositionParameters,
}) => {
    const colors = [
        { name: 'green', className: 'bg-green-500' },
        { name: 'pink', className: 'bg-pink-500' },
        { name: 'yellow', className: 'bg-yellow-500' },
        { name: 'blue', className: 'bg-blue-500' },
    ];

    return (
        <div
            className="absolute flex flex-col items-center justify-center min-h-[1.5rem] bg-gray-700 rounded-full p-2 min-w-[8rem] z-50"
            style={{
                top: ColorModalPositionParameters.top + 90,
                left: ColorModalPositionParameters.left + 200,
            }}
        >
            <div className="flex gap-2 items-center justify-center">
                {colors.map((color) => (
                    <div
                        key={color.name}
                        className={`w-4 h-4 ${color.className} rounded-full cursor-pointer`}
                        onClick={() => changeColor(color.name)}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default ColorModal;
